import { combineReducers } from 'redux'
import assessment from './assessment'
import auth from './auth'
import ccp from './ccp'
import header from './header'
import healthSystem from './healthSystem'
import patient from './patient'
import synopsis from './synopsis'
import user from './user'
import wrapup from './wrapup'

const rootReducer = combineReducers({
  assessment,
  auth,
  ccp,
  header,
  healthSystem,
  patient,
  synopsis,
  user,
  wrapup
})

export default rootReducer
